import Overlay from './src/overlay.mjs';
export { overlayEmits, overlayProps } from './src/overlay.mjs';

const ElOverlay = Overlay;

export { ElOverlay, ElOverlay as default };
//# sourceMappingURL=index.mjs.map
